export default __webpack_public_path__ + "static/how-its-work-0dc3cd8702f70e87c5a73240a4116d44.png";